export default __webpack_public_path__ + "static/topmenu06@2x-a75c860b4b666d0111a5e6511fb41bfc.png";